import React, { useEffect, useState } from 'react';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";

const PlanPopup = ({ show, currentPlan, allPlans, selectPlan, close }) => {
    const [activeTab, setActiveTab] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        const initTabs = {};
        allPlans.forEach(p => {
            initTabs[p._id] = 0;
        });
        setActiveTab(initTabs);
    }, [allPlans]);

    const handleTabClick = (planId, index) => {
        setActiveTab(prev => ({ ...prev, [planId]: index }));
    };
    const handlePlanSelect = (planId, duration) => {
        console.log(planId, duration);
        selectPlan(planId, duration);
    };
    const renderPlanCard = (plan, isCurrent = false, isFree = false) => {
        const selectedPeriodIndex = activeTab[plan._id] || 0;
        const selectedPeriod = plan.billingperiod[selectedPeriodIndex];

        return (
            <MDBCard
                className={`mb-4 shadow-sm ${isCurrent ? 'border border-success border-2' : 'border'}`}
                style={isCurrent ? { boxShadow: '0 0 8px rgba(25, 135, 84, 0.4)' } : {}}
            >
                <MDBCardBody className="d-flex flex-column justify-content-between">
                    {isCurrent && <h5 className={`${isCurrent ? 'text-success fw-bold mb-3' : ''}`}>Your current Plan <MDBIcon fas icon="caret-square-down" size="lg" /></h5>}
                    <h5 className={`${isCurrent ? 'text-success fw-bold' : ''}`}>
                        {plan.name}
                    </h5>

                    {isFree ? (
                        <div className="d-flex mb-2">
                            <MDBBtn size="sm" color="success" className='ms-2' style={{ cursor: "default" }} >Life Time</MDBBtn>
                        </div>
                    ) : (
                        <div className="d-flex mb-1">
                            {plan.billingperiod.map((bp, i) => (
                                <MDBBtn
                                    key={i}
                                    size="sm"
                                    color={activeTab[plan._id] === i ? 'success' : 'light'}
                                    className={`me-2 ${activeTab[plan._id] === i ? '' : 'border'}`}
                                    onClick={() => handleTabClick(plan._id, i)}
                                >
                                    {bp.duration} MONTHS
                                </MDBBtn>
                            ))}
                        </div>
                    )}

                    <div>
                        {selectedPeriodIndex === 1 && (
                            <del className="text-danger me-2">₹{plan.billingperiod[0]?.montly}</del>
                        )}
                        <span className="fw-bold text-dark">
                            {isFree ? <label className='ms-2 mb-2' >Free with limited features</label> : <>₹{selectedPeriod?.montly || 0}/month + GST</>}
                        </span>
                        {!isFree && <p className="text-muted mb-1">Billed for {selectedPeriod?.duration} Months</p>}
                        {selectedPeriodIndex === 1 && (<p className="text-success mb-1">You Save 10%</p>)}
                    </div>

                    <MDBBtn
                        color={isCurrent && isFree ? 'secondary' : 'success'}
                        size="sm"
                        disabled={isCurrent && isFree}
                        onClick={() => handlePlanSelect(plan._id, selectedPeriod?.duration)}
                    >
                        {isCurrent && isFree ? "Selected Plan" : "Select Plan"}
                    </MDBBtn>
                </MDBCardBody>
            </MDBCard>
        );
    };


    return (
        <MDBModal
            animationDirection="right"
            tabIndex="-1"
            open={show}
        // onClose={handleClose}
        >
            <MDBModalDialog size="xl" position="top-center">
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Select a Plan for Upgrade / Renewal</MDBModalTitle>
                        {/* <MDBBtn className="btn-close" color="none" onClick={() => navigate(-1)}></MDBBtn> */}
                    </MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow className="justify-content-center align-items-stretch">
                            {allPlans.map((plan) => {
                                const isCurrent = plan._id === (currentPlan?._id || "");
                                const isFree = plan.billingperiod.some((bp) => bp.entity == true);

                                return (
                                    plan.availability == true &&
                                    <MDBCol md="4" key={plan._id} className="d-flex">
                                        <div className="plan-card-wrapper d-flex flex-column w-100">
                                            {renderPlanCard(plan, isCurrent, isFree)}
                                        </div>
                                    </MDBCol>
                                );
                            })}
                        </MDBRow>

                        <MDBModalFooter>
                            <MDBBtn
                                size="sm"
                                color='success'
                                className="me-2"
                                onClick={() => { navigate("/commercials") }}
                            >
                                Pricing Plans
                            </MDBBtn>
                            <MDBBtn color="secondary" onClick={() => { navigate(-1) }}>Back</MDBBtn>
                            {/* <MDBBtn color="primary" onClick={(formData._id !== -1 && !formData.onetime) ? toggleAlertModal : handleSubmit}>{props.scheduleinfo ? "Update" : "Save"}</MDBBtn> */}
                        </MDBModalFooter>

                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
};

export default PlanPopup;
